import { DELIVERED_SALES_ORDER_STATUS_IDS } from './delivered-sales-order-status-ids.js';
/** Delivered orders whose payment timing counts toward avgDaysToPay; a paid order is closed to COMPLETE and must still count. */
export const PAY_HISTORY_SALES_ORDER_STATUS_IDS = new Set(DELIVERED_SALES_ORDER_STATUS_IDS);
//# sourceMappingURL=pay-history-sales-order-status-ids.js.map